import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

export const apiPathFunc =
  <T extends string>(path: T) =>
  (
    param: IExtractParams<T> extends undefined
      ? null | undefined
      : IExtractParams<T>,
  ) =>
    generatePath(path, param);

export type IExtractApiPathFunc<T> = T extends (param: infer P) => void
  ? P
  : never;
